<script setup lang="ts">
import store from '@/store'
import { ERoleActions } from '@/store/roleStore/RoleStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { defaultRoleModel, type RoleModel } from '@/types/models/RoleModel'
import { EAdminPerm } from '@/types/permissions/AdminPermissionsEnum'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AdministrationRoleDetailView from '../AdministrationRoleDetailView.vue'

const route = useRoute()
const roleId = ref(route.params.id.toString())

const data = ref<Partial<RoleModel>>({ ...defaultRoleModel })
const getRole = () =>
    store
        .dispatch(`${EStoreModules.ROLE}/${ERoleActions.FETCH_ROLE}`, roleId.value)
        .then(res => (data.value = res))

onMounted(() => {
    if (typeof roleId.value === 'string') getRole()
})

const save = () =>
    store
        .dispatch(`${EStoreModules.ROLE}/${ERoleActions.UPDATE_ROLE}`, {
            roleId: roleId.value,
            roleData: data.value
        })
        .then(() => getRole())

const updateRole = (value: Partial<RoleModel>) => (data.value = { ...data.value, ...value })
</script>

<template>
    <AdministrationRoleDetailView
        :data="data"
        :buttonLabel="$t('common.saveModifications')"
        :editPermission="EAdminPerm.ADMIN_ROLES"
        :loading="!!store.state.role.isLoading"
        @click="save"
        @update="updateRole" />
</template>
